// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Ur0y","box":"WorkspacesBox_box__3joNP","node":"WorkspacesBox_node__2PzwD"};